import Phaser from 'phaser';
import { landscapeLayout } from '../../layout/tableLayout.js';

export class CrapsTutorialBootScene extends Phaser.Scene {
  constructor() {
    super('CrapsTutorialBootScene');
  }

  preload() {
    // Load the same felt SVGs the live table uses. Texture keys match so
    // tableLayout.ts and zones.ts work as-is.
    this.textures.generate('felt', { data: ['1'.repeat(8)], pixelWidth: 16 });
    const layout = landscapeLayout(this.scale.width, this.scale.height);
    for (const panel of layout.panels) {
      const url =
        panel.svgKey === 'tableMain' ? '/craps-table-main.svg' : '/craps-table-hardway.svg';
      this.load.svg(panel.svgKey, url, {
        width: Math.round(panel.dst.w),
        height: Math.round(panel.dst.h),
      });
      const textKey = panel.svgKey === 'tableMain' ? 'tableMainSvgText' : 'tableHardwaySvgText';
      this.load.text(textKey, url);
    }
  }

  create() {
    this.scene.start('CrapsTutorialScene');
    this.scene.launch('CrapsTutorialUIScene');
    this.scene.launch('CrapsTutorialDiceOverlayScene');
  }
}
